import states from "./states"
import { UPDATE_FRACTURE_STATE, UPDATE_FRACTURE_LIST_ITEM } from "./actiontypes"

const fracture_details = (state = states.fracture_details, action) => {
  switch (action.type) {
    case UPDATE_FRACTURE_STATE:
      return {
        ...state,
        ...action.payload
      }

    case UPDATE_FRACTURE_LIST_ITEM: {
      let index = -1
      index = state.fracture_list.findIndex(record => record.id === action.payload.id)
      if (index !== -1)
        return {
          ...state,
          fracture_list: [
            ...state.fracture_list.slice(0, index),
            action.payload,
            ...state.fracture_list.slice(index + 1)
          ]
        }
      return state
    }

    default:
      return state
  }
}

export default fracture_details



// WEBPACK FOOTER //
// ./src/data/redux/fracture_details/reducers.js